<div class="container">
  <app-editable-card header="Leave of Absence">
    <app-rx-search [onlySearchReorders]="true" (rxFound)="rxFound($event)" [hideAfterEmitting]="true"></app-rx-search>
    <div *ngIf="order" class="two-column-form two-column-form--no-padding">
      <div class="labeled-data-grid">
        <div class="labeled-data-grid__label">
          <span class="sub-header">Rx #</span>
        </div>
        <span id="loa.rxNo">{{order.rxNo}}</span>
        <div class="labeled-data-grid__label">
          <span class="sub-header">Resident id</span>
        </div>
        <span id="loa.patientId">{{order.patientId}}</span>
        <div class="labeled-data-grid__label">
          <span class="sub-header">Resident</span>
        </div>
        <a id="loa.patientName" (click)="navigateToResident()">{{order.residentName}}</a>
        <div class="labeled-data-grid__label">
          <span class="sub-header">Dispensed date</span>
        </div>
        <span id="loa.dispenseDate">{{order.dispenseDate | date: 'MM/dd/yyyy'}}</span>
        <div class="labeled-data-grid__label">
          <span class="sub-header">Drug name</span>
        </div>
        <span id="loa.drugName">{{order.drugName}}</span>
        <div class="labeled-data-grid__label">
          <span class="sub-header">Directions</span>
        </div>
        <span id="loa.directions">{{order.directions}}</span>
        <div class="labeled-data-grid__label">
          <span class="sub-header">NDC</span>
        </div>
        <span id="loa.ndc">{{order.ndc}}</span>
        <div class="labeled-data-grid__label">
          <span class="sub-header">Dispensed quantity</span>
        </div>
        <span id="loa.quantity">{{order.quantity}}</span>
      </div>
      <form [formGroup]="loaForm">
        <div class="two-column-form__right">
          <div class="row">
            <div class="input-container input-container--lg">
              <label class="input-container__label">
                Quantity transferred
                <input
                  id="loa.quantity-transferred"
                  type="text"
                  mask="separator.2"
                  class="input-container__field"
                  formControlName="transferred"
                  thousandSeparator=",">
              </label>
              <span
                id="loa.transferred-required"
                *ngIf="loaForm.get('transferred')?.errors?.min && loaForm.touched"
                class="input-container__error">Transferred quantity must be greater than 0</span>
              <span
                id="loa.transferred-max"
                *ngIf="loaForm.get('transferred')?.errors?.max" class="input-container__error">Transferred quantity cannot be greater than dispensed quantity</span>
            </div>
          </div>
          <div class="row">
            <div class="input-container input-container--lg">
              <label class="input-container__label">
                Quantity returned
                <input
                  id="loa.quantity-returned"
                  type="text"
                  mask="separator.2"
                  class="input-container__field"
                  formControlName="returned"
                  thousandSeparator=",">
                </label>
                <app-control-messages
                  id="loa.returned-max"
                  class="input-container__error"
                  [control]="loaForm.get('returned')"
                  errorMessageOverride="Returned quantity cannot be greater than transferred quantity"></app-control-messages>
            </div>
          </div>
          <div class="row row--end">
            <button
              id="loa.cancel"
              type="button"
              class="btn btn--tertiary"
              (click)="reset()">Cancel
            </button>
            <button
              id="loa.add"
              type="button"
              class="btn btn--primary-outline"
              [ngClass]="{'disabled': !loaForm.valid}"
              [disabled]="!loaForm.valid"
              (click)="add()">Add item
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="grid-wrapper" *ngIf="addedOrders.length > 0">
      <dx-data-grid [dataSource]="addedOrders" [showBorders]="true" [columnAutoWidth]="true" [wordWrapEnabled]="true">
        <dxo-paging [pageSize]="10"></dxo-paging>
        <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 20]" [showInfo]="true"></dxo-pager>
        <dxi-column dataField="rxNo" caption="Rx #"></dxi-column>
        <dxi-column dataField="patientId" caption="Resident ID"></dxi-column>
        <dxi-column dataField="residentName" caption="Resident Name"></dxi-column>
        <dxi-column dataField="dispenseDate" caption="Dispensed Date" dataType="date" format="MM/dd/yyyy"></dxi-column>
        <dxi-column dataField="drugName" caption="Drug Name"></dxi-column>
        <dxi-column dataField="directions" caption="Directions"></dxi-column>
        <dxi-column dataField="quantity" caption="Quantity Dispensed"></dxi-column>
        <dxi-column dataField="quantityTransferred" caption="Quantity Transferred"></dxi-column>
        <dxi-column dataField="quantityReturned" caption="Quantity Returned"></dxi-column>
        <dxi-column caption="Remove" [allowSorting]="false" alignment="center" cellTemplate="actions"></dxi-column>
        <div *dxTemplate="let cell of 'actions'">
          <i name="close" class="material-icons-outlined remove-icon" (click)="remove(cell.data)">delete</i>
        </div>
      </dx-data-grid>
    </div>
    <div class="row row--end" *ngIf="addedOrders.length > 0">
      <div class="checkbox-container__item pretty p-default p-curve">
        <input id="loa.print-monographs" type="checkbox" [checked]="printMonographs" (change)="printMonographs = !printMonographs">
        <div class="state p-primary">
          <label>Include patient monographs</label>
        </div>
      </div>
    </div>
    <div *ngIf="addedOrders.length > 0" class="row row--end">
      <button
        id="loa.clear"
        type="button"
        class="btn btn--tertiary"
        (click)="clear()">Clear
      </button>
      <button
        id="loa.view"
        type="button"
        class="btn btn--primary"
        (click)="view()">View report
      </button>
    </div>
  </app-editable-card>
</div>
